module.exports = __webpack_public_path__ + "static/operationBlockUpload-74ff986c01b21e575b25390624f2cfaf.png";